var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M7.881 16.244c.493-.427 1.142-.735 1.842-.937A8.308 8.308 0 0 1 12 15c.786 0 1.57.103 2.277.307c.7.202 1.35.51 1.842.937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 1.25,
    fill: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 10,
    r: 1.25,
    fill: "currentColor",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadSmiley);
export default __webpack_public_path__ + "static/media/sad-smiley.25ea7f1358125483d18a897412b644bf.svg";
export { ForwardRef as ReactComponent };